import { render, staticRenderFns } from "./load-sinester-file.vue?vue&type=template&id=8e706f68&scoped=true"
import script from "./load-sinester-file.vue?vue&type=script&lang=js"
export * from "./load-sinester-file.vue?vue&type=script&lang=js"
import style0 from "./load-sinester-file.vue?vue&type=style&index=0&id=8e706f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e706f68",
  null
  
)

export default component.exports